"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.create = exports.getNotices = void 0;
var Staff_1 = require("@cck/common/dist/data/Staff");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var fbase_1 = require("../firebase/fbase");
var StaffManager = __importStar(require("../rcm/StaffManager"));
var COLLECTION_NAME = 'NOTICE';
function getNotices() {
    return __awaiter(this, void 0, void 0, function () {
        var noticeDocs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).get()];
                case 1:
                    noticeDocs = (_a.sent()).docs;
                    return [2 /*return*/, lodash_1.default.map(noticeDocs, function (noticeDoc) {
                            var notice = noticeDoc.data();
                            notice.id = noticeDoc.id;
                            if (lodash_1.default.isEmpty(notice)) {
                                throw new Error('해당 공지사항의 데이터가 비어있습니다.');
                            }
                            return notice;
                        })];
            }
        });
    });
}
exports.getNotices = getNotices;
/**
 *
 * @param {Notice} newNotice 새로 생성할 Notice
 * @returns {Promise<void>}
 */
function create(title, content) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var currentUserId, staff, currentTime, collectionRef, notice, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (lodash_1.default.isEmpty(title)) {
                        return [2 /*return*/, Promise.reject(new Error('공지사항 작성 - 제목을 입력해주세요'))];
                    }
                    currentUserId = (_a = fbase_1.authService === null || fbase_1.authService === void 0 ? void 0 : fbase_1.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                    if (!currentUserId) {
                        return [2 /*return*/, Promise.reject(new Error('공지사항 작성 - 로그인한 유저를 찾을 수 없습니다.'))];
                    }
                    return [4 /*yield*/, StaffManager.get(currentUserId)];
                case 1:
                    staff = _b.sent();
                    if ((staff === null || staff === void 0 ? void 0 : staff.level) !== Staff_1.Level.ADMIN) {
                        return [2 /*return*/, Promise.reject(new Error('공지사항 작성 - 권한이 없습니다.'))];
                    }
                    currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                    collectionRef = fbase_1.dbService.collection(COLLECTION_NAME);
                    notice = {
                        title: title,
                        content: content,
                        createTime: currentTime,
                        writer: currentUserId,
                        isVisible: true
                    };
                    return [4 /*yield*/, collectionRef.add(notice)];
                case 2:
                    result = _b.sent();
                    if (!result.id) {
                        return [2 /*return*/, Promise.reject(new Error('공지사항 작성에 실패했습니다.'))];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.create = create;
/**
 *
 * @param noticeId
 * @param visibleState
 * @returns {Promise<void>}
 */
function remove(noticeId) {
    return __awaiter(this, void 0, void 0, function () {
        var docRef, documentObject;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    docRef = fbase_1.dbService.collection(COLLECTION_NAME).doc(noticeId);
                    return [4 /*yield*/, docRef.get()];
                case 1:
                    documentObject = _a.sent();
                    if (!documentObject.exists) {
                        return [2 /*return*/, Promise.reject(new Error('해당 아이디의 공지사항 글이 존재하지 않습니다.'))];
                    }
                    return [2 /*return*/, docRef.update({ isVisible: false })];
            }
        });
    });
}
exports.remove = remove;
//# sourceMappingURL=NoticeManager.js.map